import { motion } from "framer-motion";
import img from "../../assets/images/hero-image-12.jpg";
import TypingText from "../utils/TypingText";

const processSteps = [
  { number: "1", title: "Trail Mapping", description: "We chart a custom adventure route, exploring hidden trails, secret waterfalls, and panoramic viewpoints tailored just for you." },
  { number: "2", title: "Gear Up & Prep", description: "Get equipped with the right gear and guidance. We prepare your body and mind for the adventure ahead, ensuring a safe and thrilling journey." },
  { number: "3", title: "Into the Wild", description: "Step into nature's embrace. Hike through forests, climb rugged cliffs, and paddle across serene lakes while our guides ensure an unforgettable experience." },
  { number: "4", title: "Campfire Reflections", description: "End your day around a crackling campfire, share stories, savor local flavors, and reflect on the adventure before resting under a starry sky." },
];

export default function HorizontalProcessSection() {

  return (
    <section className="relative bg-gray-50">
      {/* Background */}
      <div
        className="absolute inset-0 z-0 bg-cover bg-center filter blur-sm opacity-80"
        style={{
          backgroundImage: `url(${img})`,
          backgroundAttachment: "fixed",
        }}
      ></div>

      {/* Heading */}
      <div className="py-6 px-10 flex flex-col items-center relative z-20 pt-20">
        <h1 className="text-center text-4xl md:text-6xl font-serif font-bold mb-6 text-[#162230]">
          Everwild Expeditions
        </h1>
        <p className="max-w-2xl text-center text-[#162230] mb-8">
          Embark on a journey where untamed wilderness meets unforgettable experiences.
        </p>
      </div>

      {/* Cards */}

      <div
        className="
          relative z-10 mx-auto pb-20
          grid gap-8
          grid-cols-1
          min-[768px]:grid-cols-2
          min-[1500px]:grid-cols-4

          px-6 sm:px-16 md:px-16
        

          max-w-[1500px]
        "
      >
        {processSteps.map((step, index) => (
          <StaticCard key={index} step={step} />
        ))}
      </div>




    </section>
  );
}

function StaticCard({ step }) {
  return (
    <motion.div
      className="
        relative rounded-[48px]
        w-full h-full
        p-10
        bg-white/10 backdrop-blur-md
        shadow-lg overflow-hidden
        border border-white/10
      "
    >
      {/* Watermark */}
      <h3
        className="
          absolute inset-0
          text-[100px] md:text-[140px] min-[1500px]:text-[180px]
          font-bold text-gray-200/10
          leading-none select-none pointer-events-none
          flex items-center justify-center text-center px-6
        "
      >
        {step.title.toUpperCase()}
      </h3>

      <div className="relative z-10">
        <div className="text-[72px] md:text-[88px] font-medium text-white mb-4">
          {step.number}
        </div>

        <h3 className="text-xl md:text-2xl font-semibold mb-3">
          <TypingText text={step.title} />
        </h3>

        <p className="text-gray-100 text-base md:text-lg">
          {step.description}
        </p>
      </div>
    </motion.div>
  );
}


